import React from "react";
import { CustomFieldSchemaFragment, Option } from "__generated__/graphql";
import { CheckboxGroup, ICheckboxOption } from "common/checkbox";

interface ICustomListMultiSelectFieldProps {
  value: Option[] | null;
  setValue: (value: Option[] | null) => void;
  schema?: CustomFieldSchemaFragment | null;
  showLabel?: boolean;
  labelledById?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}
export const CustomListMultiSelectField = ({
  value = [],
  setValue,
  schema,
}: ICustomListMultiSelectFieldProps) => {
  const options: ICheckboxOption[] =
    schema?.optionChoices?.map((optionChoice) => ({
      label: optionChoice.value,
      value: optionChoice.id,
      "data-custom-css-value": optionChoice.value, // for form custom css
    })) || [];

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedId = event.target.value;
    const selectedOption = schema?.optionChoices?.find(
      (option) => option.id === selectedId,
    );

    if (selectedOption) {
      const optionObject = {
        colour: selectedOption.colour,
        value: selectedOption.value,
        id: selectedOption.id,
      };

      if (event.target.checked) {
        setValue(value ? [...value, optionObject] : [optionObject]);
      } else {
        setValue(value?.filter((v) => v.id !== selectedId) || []);
      }
    }
  };

  return (
    <CheckboxGroup
      label=""
      options={options}
      onChange={handleChange}
      values={value?.map((v) => v.id) || []}
    />
  );
};
